@if (formGroup) {
	@if (getControl(); as control) {
		<div [formGroup]="formGroup" class="metabi-control">
			@if (!noLabel) {
				<app-field-label [for]="formGroupOrControlName">
					{{ getLabel() }}
				</app-field-label>
				<br />
			}
			<nz-select
				[formControl]="control"
				name="option"
				nzShowSearch
				[nzServerSearch]="true"
				[nzLoading]="loading()"
				[nzPlaceHolder]="placeholder || 'Search...'"
				(nzOnSearch)="onSearch($event)"
				(ngModelChange)="onChange($event)"
			>
				@for (option of options(); track option.value) {
					<nz-option [nzValue]="option.value" [nzLabel]="option.label"></nz-option>
				}
			</nz-select>
			@if (control.errors && control.touched) {
				<app-field-error>
					{{ curateValidationHint(control) }}
				</app-field-error>
			}
		</div>
	}
}
